// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Login / Password
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import ResetPassword from 'src/components/Dashboard/Views/Pages/ResetPassword.vue'

// Demo
// import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
// import AbfrageJohn from 'src/components/Dashboard/Views/AbfrageJohn.vue'
// import TeamEvaluation from 'src/components/Dashboard/Views/TeamEvaluation.vue'
// import UserEvaluation from 'src/components/Dashboard/Views/UserEvaluation.vue'
// import UserAuswertungJohn from 'src/components/Dashboard/Views/UserAuswertungJohn.vue'
// const TaskList = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/TaskList.vue')

// Dashboard pages
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'

const UserProfile = () => import(/* webpackChunkName: "profile" */ 'src/components/Dashboard/Views/Pages/UserProfile.vue')
const ChangePassword = () => import(/* webpackChunkName: "profile" */ 'src/components/Dashboard/Views/Pages/ChangePassword.vue')
const UserFeedback = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Dashboard/UserFeedback.vue')

const Overview = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')
const UserList = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Users/UserList.vue')
const UserEdit = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Users/UserEdit.vue')
const TeamList = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Teams/TeamList.vue')
const TeamForm = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Teams/TeamForm.vue')
const QuestionnaireList = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Questionnaires/QuestionnaireList.vue')
const QuestionnaireForm = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Questionnaires/QuestionnaireForm.vue')
const QuestionCategoryList = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Questionnaires/QuestionCategoryList.vue')
const QuestionList = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Questionnaires/QuestionList.vue')
const NewsList = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/News/NewsList.vue')
const NewsEdit = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/News/NewsEdit.vue')
const Settings = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Settings/Settings.vue')
const Info = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Info/Info.vue')
const GDPR = () => import(/* webpackChunkName: "dashboard" */ 'src/components/Dashboard/Views/Info/GDPR.vue')

// User Pages
const News = () => import(/* webpackChunkName: "general" */ 'src/components/Views/News/News.vue')
const NewsDetails = () => import(/* webpackChunkName: "general" */ 'src/components/Views/News/NewsDetails.vue')
const Queries = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Queries/Queries.vue')
const QueryAnswer = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Queries/QueryAnswer.vue')
const QueryResult = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Queries/QueryResult.vue')
const TeamContainer = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Team/TeamContainer.vue')
const TeamQuestionnaires = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Team/TeamQuestionnaires.vue')
const TeamSelection = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Team/TeamSelection.vue')
const TeamView = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Team/TeamView.vue')
const TeamMemberView = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Team/TeamMemberView.vue')
const TeamPdf = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Team/TeamPdf.vue')
const Tasks = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Tasks/Tasks.vue')
const TaskForm = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Tasks/TaskForm.vue')
const Waveline = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Waveline/Waveline.vue')
const WavelineContainer = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Waveline/WavelineContainer.vue')
const WavelineQuestionnaireSelection = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Waveline/QuestionnaireSelection.vue')
const WavelineTeamSelection = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Waveline/TeamSelection.vue')
const WavelineUserSelection = () => import(/* webpackChunkName: "general" */ 'src/components/Views/Waveline/UserSelection.vue')

const loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

const passwordResetPages = [
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: ResetPassword
  },
  {
    path: '/confirm-password-reset/:token?',
    name: 'PasswordResetConfirm',
    component: ResetPassword
  }
]

const pdfExportPage = {
  path: '/pdfexport/:qid/:tid/:months',
  name: 'TeamPdf',
  component: TeamPdf
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: '/admin/overview',
        name: 'MyCompany',
        component: Overview,
        meta: {
          breadcrumb: [
            { name: 'MyCompany', label: 'My Company' }
          ]
        }
      },
      {
        path: '/admin/overview/news',
        name: 'News',
        component: News,
        meta: {
          breadcrumb: [
            { name: 'MyCompany', label: 'My Company' },
            { name: 'News', label: 'All News' }
          ]
        }
      },
      {
        path: '/admin/overview/news/:id',
        component: NewsDetails,
        name: 'NewsDetails',
        meta: {
          breadcrumb: [
            { name: 'MyCompany', label: 'My Company' },
            { name: 'News', label: 'All News' },
            { name: 'NewsDetails', label: 'Details' }
          ]
        }
      },
      {
        path: '/queries',
        component: Queries,
        name: 'Queries',
        meta: {
          breadcrumb: [
            { name: 'Queries', label: 'My Queries' }
          ]
        }
      },
      {
        path: '/queries/:id/answer',
        component: QueryAnswer,
        name: 'QueryAnswer',
        meta: {
          breadcrumb: [
            { name: 'Queries', label: 'My Queries' },
            { name: 'QueryAnswer' }
          ]
        }
      },
      {
        path: '/queries/:id/result',
        component: QueryResult,
        name: 'QueryResult',
        meta: {
          breadcrumb: [
            { name: 'Queries', label: 'My Queries' },
            { name: 'QueryResult' }
          ]
        }
      },
      {
        path: 'team',
        name: 'TeamContainer',
        component: TeamContainer,
        children: [
          {
            path: 'reports',
            name: 'TeamQuestionnaires',
            component: TeamQuestionnaires,
            meta: {
              breadcrumb: [
                { name: 'TeamQuestionnaires', label: 'Query selection' }
              ]
            },
          },
          {
            path: 'questionnaire/:qid',
            name: 'TeamSelection',
            component: TeamSelection,
            meta: {
              breadcrumb: [
                { name: 'TeamQuestionnaires', label: 'Query selection' },
                { name: 'TeamSelection', label: 'Team selection' }
              ]
            },
          },
          {
            path: 'questionnaire/:qid/team/:tid',
            name: 'TeamView',
            component: TeamView,
            meta: {
              breadcrumb: [
                { name: 'TeamQuestionnaires', label: 'Query selection' },
                { name: 'TeamSelection', label: 'Team selection' },
                { name: 'TeamView', label: 'My Team' }
              ]
            },
          },
          {
            path: 'questionnaire/:qid/team/:tid/member/:mid',
            name: 'TeamViewMember',
            component: TeamView,
            meta: {
              breadcrumb: [
                { name: 'TeamQuestionnaires', label: 'Query selection' },
                { name: 'TeamSelection', label: 'Team selection' },
                { name: 'TeamView', label: 'My Team' },
                { label: 'Member' }
              ]
            },
          },
          {
            path: 'member/:id',
            name: 'TeamMemberView',
            component: TeamMemberView,
            meta: {
              breadcrumb: [
                { name: 'TeamView', label: 'My Team' }
              ]
            }
          }
        ]
      },
      {
        path: 'waveline',
        name: 'WavelineContainer',
        component: WavelineContainer,
        meta: {
          breadcrumb: [
            // { name: 'WavelineContainer', label: 'Waveline' }
          ]
        },
        children: [
          {
            path: 'questionnaires',
            name: 'WavelineQuestionnaireSelection',
            component: WavelineQuestionnaireSelection,
            meta: {
              breadcrumb: [
                { name: 'WavelineQuestionnaireSelection', label: 'Query selection' }
              ]
            },
          },
          {
            path: 'questionnaire/:qid',
            name: 'WavelineTeamSelection',
            component: WavelineTeamSelection,
            meta: {
              breadcrumb: [
              //   { name: 'WavelineContainer', label: 'Waveline' },
              //   { name: 'WavelineQuestionnaireSelection', label: 'Report selection' },
              //   { name: 'WavelineTeamSelection', label: 'Team selection' }
              ]
            },
          },
          {
            path: 'questionnaire/:qid/team/:tid/user',
            name: 'WavelineUserSelection',
            component: WavelineUserSelection,
            meta: {
              breadcrumb: [
                // { name: 'WavelineContainer', label: 'Waveline' },
                // { name: 'WavelineQuestionnaireSelection', label: 'Report selection' },
                // { name: 'WavelineTeamSelection', label: 'Team selection' },
                // { name: 'WavelineUserSelection', label: 'User selection' }
              ]
            },
          },
          {
            path: 'questionnaire/:qid/team/:tid',
            name: 'WavelineTeamView',
            component: Waveline,
            meta: {
              breadcrumb: [
                // { name: 'WavelineContainer', label: 'Waveline' },
                // { name: 'WavelineQuestionnaireSelection', label: 'Report selection' },
                // { name: 'WavelineTeamSelection', label: 'Team selection' },
                // { label: 'Team' }
              ]
            },
          },
          {
            path: 'questionnaire/:qid/team/:tid/user/:uid',
            name: 'WavelineUserView',
            component: Waveline,
            meta: {
              breadcrumb: [
                // { name: 'WavelineContainer', label: 'Waveline' },
                // { name: 'WavelineQuestionnaireSelection', label: 'Report selection' },
                // { name: 'WavelineTeamSelection', label: 'Team selection' },
                // { name: 'WavelineUserSelection', label: 'User selection' },
                // { label: 'User' }
              ]
            },
          }
        ]
      },
      {
        path: '/info',
        name: 'Info',
        component: Info,
        meta: {
          breadcrumb: [
            { name: 'Info', label: 'Info' }
          ]
        }
      },
      {
        path: '/info/gdpr',
        name: 'GDPR',
        component: GDPR,
        meta: {
          breadcrumb: [
            { name: 'Info', label: 'Info' },
            { name: 'GDPR', label: 'GDPR' }
          ]
        }
      }
    ]
  },
  loginPage,
  ...passwordResetPages,
  pdfExportPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'tasks',
        name: 'TaskList',
        component: Tasks,
        meta: {
          breadcrumb: [
            { name: 'TaskList', label: 'Tasks' }
          ]
        }
      },
      {
        path: 'tasks/manage/:id',
        name: 'TaskEdit',
        meta: {
          breadcrumb: [
            { name: 'TaskList', label: 'Tasks' },
            { name: 'TaskEdit', label: 'Task Management' }
          ]
        },
        component: TaskForm
      },
      {
        path: 'tasks/create',
        name: 'TaskCreate',
        component: TaskForm,
        meta: {
          breadcrumb: [
            { name: 'TaskList', label: 'Tasks' },
            { name: 'TaskCreate', label: 'Task Management' }
          ]
        }
      },
      {
        path: '/account',
        name: 'UserProfile',
        component: UserProfile,
        meta: {
          breadcrumb: [
            { name: 'UserProfile', label: 'My Account' }
          ]
        }
      },
      {
        path: '/changePassword',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
          breadcrumb: [
            { name: 'ChangePassword', label: 'Change Password' }
          ]
        }
      },
      {
        path: '/userFeedback',
        name: 'UserFeedback',
        component: UserFeedback,
        meta: {
          breadcrumb: [
            { name: 'UserFeedback', label: 'Feedback' }
          ]
        }
      },
      {
        path: 'users',
        name: 'UserList',
        component: UserList,
        meta: {
          breadcrumb: [
            { name: 'UserList', label: 'Users' }
          ]
        }
      },
      {
        path: 'users/manage/:id',
        name: 'UserEdit',
        meta: {
          breadcrumb: [
            { name: 'UserList', label: 'Users' },
            { name: 'UserEdit', label: 'User Administration' }
          ]
        },
        component: UserEdit
      },
      {
        path: 'users/create',
        name: 'UserCreate',
        component: UserEdit,
        meta: {
          breadcrumb: [
            { name: 'UserList', label: 'Users' },
            { name: 'UserEdit', label: 'Add New User' }
          ]
        }
      },
      {
        path: 'teams',
        name: 'TeamList',
        component: TeamList,
        meta: {
          breadcrumb: [
            { name: 'TeamList', label: 'Teams' }
          ]
        }
      },
      {
        path: 'teams/manage/:id',
        name: 'TeamEdit',
        component: TeamForm,
        meta: {
          breadcrumb: [
            { name: 'TeamList', label: 'Teams' },
            { name: 'TeamEdit', label: 'Team Management' }
          ]
        }
      },
      {
        path: 'teams/create',
        name: 'TeamCreate',
        component: TeamForm,
        meta: {
          breadcrumb: [
            { name: 'TeamList', label: 'Teams' },
            { name: 'TeamEdit', label: 'Add New Team' }
          ]
        }
      },
      {
        path: 'questionnaires',
        name: 'QuestionnaireList',
        component: QuestionnaireList,
        meta: {
          breadcrumb: [
            { name: 'QuestionnaireList', label: 'Questionnaires' }
          ]
        }
      },
      {
        path: 'questionnaires/manage/:id',
        name: 'QuestionnaireEdit',
        component: QuestionnaireForm,
        meta: {
          breadcrumb: [
            { name: 'QuestionnaireList', label: 'Questionnaires' },
            { name: 'QuestionnaireEdit', label: 'Questionnaire Management' }
          ]
        }
      },
      {
        path: 'questionnaires/create',
        name: 'QuestionnaireCreate',
        component: QuestionnaireForm,
        meta: {
          breadcrumb: [
            { name: 'QuestionnaireList', label: 'Questionnaires' },
            { name: 'QuestionnaireEdit', label: 'New Questionnaire' }
          ]
        }
      },
      {
        path: 'questionnaires/categories',
        name: 'QuestionCategoryList',
        component: QuestionCategoryList,
        meta: {
          breadcrumb: [
            { name: 'QuestionnaireList', label: 'Questionnaires' },
            { name: 'QuestionCategoryList', label: 'Question Library' }
          ]
        }
      },
      {
        path: 'questionnaires/categories/manage/:id',
        name: 'QuestionList',
        component: QuestionList,
        meta: {
          breadcrumb: [
            { name: 'QuestionnaireList', label: 'Questionnaires' },
            { name: 'QuestionCategoryList', label: 'Question Library' },
            { name: 'QuestionList', label: 'Questions' }
          ]
        }
      },
      {
        path: 'news',
        name: 'NewsList',
        component: NewsList,
        meta: {
          breadcrumb: [
            { name: 'NewsList', label: 'News' }
          ]
        }
      },
      {
        path: 'news/create',
        name: 'NewsCreate',
        component: NewsEdit,
        meta: {
          breadcrumb: [
            { name: 'NewsList', label: 'News' },
            { name: 'NewsCreate', label: 'Create News' }
          ]
        }
      },
      {
        path: 'news/manage/:id',
        name: 'NewsEdit',
        component: NewsEdit,
        meta: {
          breadcrumb: [
            { name: 'NewsList', label: 'News' },
            { name: 'NewsEdit', label: 'Edit News' }
          ]
        }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        meta: {
          breadcrumb: [
            { name: 'Settings', label: 'Settings' }
          ]
        }
      }
    ]
  },
  {path: '*', component: NotFound}
];

export default routes
